const prefetchedRoutes = new Set<string>();

const routeImportMap: Record<string, () => Promise<unknown>> = {
  '/app/products': () => import('@/features/products/pages/ProductsPage'),
  '/app/free-text': () => import('@/features/free-text/pages/FreeTextPage'),
  '/app/ecommerce': () => import('@/features/ecommerce/pages/EcommercePage'),
  '/app/campaigns': () => import('@/features/campaigns/pages/CampaignsPage'),
};

export function prefetchRoute(path: string): void {
  const normalizedPath = path.split('?')[0] ?? path;
  if (prefetchedRoutes.has(normalizedPath)) return;

  const importFn = routeImportMap[normalizedPath];
  if (importFn) {
    prefetchedRoutes.add(normalizedPath);
    void importFn();
  }
}

export function _resetForTesting(): void {
  prefetchedRoutes.clear();
}
